// extracted by mini-css-extract-plugin
export var label = "_5e-1";
export var reminder = "_5e-0";